import { instanceConexao } from "services/axiosServices";
import { AxiosRequestConfig } from "axios";

/**
 * Função para retornar empreendimentos da revenda por autônomo
 *
 * @param {Object} params - Parâmetros para listagem.
 * @param {string} params.authToken - Token de autenticação do usuário.
 * @param {string} params.idAutonomo - ID do autônomo.
 * @returns {Promise<any>} - Resposta da API.
 */
export const postEmpreendimentosAutonomo = async ({
  authToken,
  idAutonomo,
}: {
  authToken: string;
  idAutonomo: string;
}): Promise<any> => {
  const url =
    "/api/RevendaEmpreendimento/ListarRevendaEmpreendimentoPorAutonomo";
  const config: AxiosRequestConfig = {
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
  };
  const response = await instanceConexao.post(url, { idAutonomo }, config);
  return response?.data;
};
